import ViewDocument from './components/ViewDocument';

const routes = [
  {
    path: '/PublicSearch/ViewDocument',
    renderer: (params = {}): JSX.Element => <ViewDocument {...params} />,
  }
];

export default routes;
